var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('company-list',_vm._g(_vm._b({},'company-list',{ companies: _vm.companies },false),{ select: _vm.select, create: _vm.create, search: _vm.search, filter: _vm.filter, updateFavorite: _vm.updateFavorite }))}
var staticRenderFns = []

export { render, staticRenderFns }